import { useContext } from 'react';
import { AccordionPanelGroupContext } from './context.es.js';

/**
 * AccordionPanelGroup context hook.
 */ const useAccordionPanelGroupContext = ()=>{
    return useContext(AccordionPanelGroupContext);
};

export { useAccordionPanelGroupContext };
//# sourceMappingURL=index.es.js.map
